import { useEffect } from 'react';
import { trackFunnelEvent } from '../analytics';

// GA4's existing tag/enhanced measurement owns page_view. Do not duplicate it here.
export default function AnalyticsTracking() {
  useEffect(() => {
    const started = new Set<string>();
    const click = (event: MouseEvent) => {
      const anchor = (event.target as Element | null)?.closest?.('a[href]');
      if (!anchor) return;
      try {
        const url = new URL(anchor.getAttribute('href') || '', window.location.href);
        if (url.hostname === 'cal.com') trackFunnelEvent('booking_click', { destination: 'cal.com', page_path: window.location.pathname });
        if (url.hostname === 'www.skool.com' || url.hostname === 'skool.com') trackFunnelEvent('skool_click', { destination: 'skool.com', page_path: window.location.pathname });
      } catch { /* Ignore invalid link targets. */ }
    };
    const focus = (event: FocusEvent) => {
      if (!(event.target as Element | null)?.closest?.('#free-help-qualification')) return;
      const path = window.location.pathname;
      if (started.has(path)) return;
      started.add(path);
      trackFunnelEvent('application_start', { form_id: 'free_help', page_path: path });
    };
    document.addEventListener('click', click, true);
    document.addEventListener('focusin', focus);
    return () => { document.removeEventListener('click', click, true); document.removeEventListener('focusin', focus); };
  }, []);
  return null;
}
